<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش ارسال رایگان باشگاه مشتریان</h5>
        <div style="flex: 1"></div>
        <button @click="print" class="btn btn-primary">
          <span style="transform: translateY(3px)" class="feather-printer"></span>
        </button>
      </div>

      <div class="row px-4 not-in-print">
        <form autocomplete="chrome-off" @submit.prevent="doFilter" class="col-12 row">
          <div class="col-4">
            <DatePickerRange
              :fromFormatType="'YYYY-MM-DD'"
              :toFormatType="'YYYY-MM-DD'"
              :fromType="'date'"
              :toType="'date'"
              :dfFType="'jYYYY-jMM-jDD'"
              :dfTType="'jYYYY-jMM-jDD'"
              v-model="filter.date"
            />
          </div>
          <div class="col-3">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
          </div>
        </form>
      </div>

      <div id="print" class="p-4">
        <div class="print-only">
          <h4>فروشگاه الینور</h4>
        </div>
        <br />
        <div class="d-flex mb-3 mr-2-print">
          <div v-if="appliedFilter.date.startDate">
            <span>از</span>
            <span class="font-weight-bold mx-1">تاریخ</span>
            <span> {{ appliedFilter.date.startDate | persianDate }}</span>
          </div>
          <div class="mr-3" v-if="appliedFilter.date.endDate">
            <span>تا</span>
            <span class="font-weight-bold mx-1">تاریخ</span>
            <span> {{ appliedFilter.date.endDate | persianDate }} </span>
          </div>
        </div>

        <b-table
          id="main-table"
          v-if="orders && orders.data"
          bordered
          striped
          :fields="fields"
          :items="orders.data"
          responsive="sm"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 + (currentPage - 1) * perPage }}
          </template>

          <template v-slot:cell(order_id)="data">
            <router-link :to="'/admin/orders/show/' + data.item.id">
              {{ data.item.id }}
            </router-link>
          </template>

          <template v-slot:cell(customer)="data">
            <router-link
              v-if="data.item.customer_id"
              :to="'/admin/customers/show/' + data.item.customer_id"
            >
              {{ fullName(data.item) }}
            </router-link>
            <span v-else>-</span>
          </template>

          <template v-slot:cell(city)="data">
            {{ data.item.city || "-" }}
          </template>

          <template v-slot:cell(shipping_name)="data">
            {{ data.item.shipping ? data.item.shipping.name : "-" }}
          </template>

          <template v-slot:cell(total_amount)="data">
            {{ data.item.total_amount | price }}
          </template>

          <template v-slot:cell(discount_amount)="data">
            {{ data.item.discount_amount | price }}
          </template>

          <template v-slot:cell(shipping_amount)="data">
            {{ data.item.shipping_amount | price }}
          </template>

          <template v-slot:cell(status)="data">
            {{ getStatusLabel(data.item.status) || data.item.status || "-" }}
          </template>

          <template v-slot:cell(free_shipping_by_club)="data">
            {{ data.item.free_shipping_by_club ? "بله" : "خیر" }}
          </template>

          <template v-slot:cell(created_at)="data">
            {{ data.item.created_at | persianDate }}
          </template>

          <template #bottom-row>
            <b-td colspan="5">جمع کل (همه صفحات):</b-td>
            <b-td>{{ totals.amount | price }}</b-td>
            <b-td colspan="6">تعداد سفارش: {{ totals.items_count }}</b-td>
          </template>
        </b-table>

        <div v-else-if="!orders" class="alert alert-primary">در حال بارگزاری</div>

        <div v-if="orders && orders.data && !orders.data.length" class="alert alert-primary">
          اطلاعاتی موجود نیست
        </div>

        <pagination
          v-if="orders && orders.data && orders.data.length"
          class="not-in-print"
          :router="true"
          :disabled="disabled"
          :limit="2"
          :data="orders"
          @pagination-change-page="changePage"
        />
      </div>
    </div>
  </main>
</template>

<script>
import { BTable, BTd } from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import { getStatusLabel } from "@@/core/libraries/adminFunctions";

function Filter() {
  this.date = {
    startDate: "",
    endDate: "",
  };
}

Filter.prototype.set = function (filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "freeShippingByClub",
  components: {
    DatePickerRange,
    BTable,
    BTd,
  },
  data() {
    return {
      disabled: false,
      orders: null,
      totals: { amount: 0, items_count: 0 },
      fields: [
        { key: "index", label: "ردیف" },
        { key: "order_id", label: "شماره سفارش" },
        { key: "customer", label: "مشتری" },
        { key: "city", label: "شهر" },
        { key: "shipping_name", label: "روش ارسال" },
        { key: "total_amount", label: "مبلغ سفارش" },
        { key: "discount_amount", label: "تخفیف" },
        { key: "shipping_amount", label: "هزینه ارسال دریافتی" },
        { key: "status", label: "وضعیت" },
        { key: "free_shipping_by_club", label: "ارسال رایگان باشگاه" },
        { key: "created_at", label: "تاریخ ثبت" },
      ],
      totalRows: 0,
      perPage: 0,
      currentPage: 1,
      filter: new Filter(),
      appliedFilter: new Filter(),
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    getStatusLabel,
    print() {
      window.print();
    },
    doFilter() {
      this.currentPage = 1;
      this.loadData();
    },
    changePage(page = 1) {
      this.currentPage = page;
      this.loadData();
    },
    fullName(item) {
      const name = [item.first_name, item.last_name].filter(Boolean).join(" ");
      return name || "بدون نام";
    },
    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;

        const response = await this.$axios.get("admin/reports/free-shipping-by-club", {
          params: {
            from_date: this.appliedFilter.date.startDate || "",
            to_date: this.appliedFilter.date.endDate || "",
            page: this.currentPage,
          },
        });

        const result = response.data.data;
        this.orders = result.orders;
        this.totals = result.totals || { amount: 0, items_count: 0 };
        this.totalRows = result.orders.total;
        this.perPage = result.orders.per_page;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>

<style>
.print-only {
  display: none;
}
@media print {
  .not-in-print {
    display: none !important;
  }
  .app-content .side-app {
    padding: 0 !important;
  }
  .print-only {
    display: flex;
    justify-content: center;
  }
  body * {
    visibility: hidden;
  }
  #print,
  #print * {
    visibility: visible;
    font-size: 1.25rem;
  }
  #print {
    padding: 0 !important;
    width: 100%;
  }
  #print .not-in-print {
    display: none;
  }
  .mr-2-print {
    margin-right: 20px;
  }
}
</style>